{"PT_VERSION":"20260723110320-87865e64"}